import { c as _c } from "react/compiler-runtime";
import { ContentCard, type ImageComponent } from "fansunited-sports-ui";
import { FillImage } from "@/components/ui/FillImage";
import type { PostGridProps } from "./types";

/**
 * Default variant: Hero cards with title overlay (grid view)
 */
export function PostGridDefault(t0) {
  const $ = _c(18);
  const {
    posts,
    title,
    getImageUrl,
    className,
    columns,
    buildLink
  } = t0;
  let t1;
  if ($[0] !== columns) {
    t1 = () => {
      if (columns === 1) {
        return "grid-cols-1";
      }
      if (columns === 2) {
        return "grid-cols-2";
      }
      if (columns === 3) {
        return "grid-cols-3";
      }
      return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
    };
    $[0] = columns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getGridCols = t1;
  let t2;
  if ($[2] !== title) {
    t2 = title && <h2 className="text-2xl font-bold mb-6">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `grid ${getGridCols()} gap-6`;
  let t4;
  if ($[4] !== buildLink || $[5] !== getImageUrl || $[6] !== posts) {
    let t5;
    if ($[8] !== buildLink || $[9] !== getImageUrl) {
      t5 = post => <ContentCard key={post.id} content={{
        id: String(post.id),
        type: post.type === "video" ? "video" : "article",
        link: buildLink(post),
        title: post.title,
        image: {
          url: getImageUrl(post.heroImage) || "",
          alt: post.title
        }
      }} variant="hero" ImageComponent={FillImage as ImageComponent} styles={{
        typography: {
          title: "text-lg font-semibold leading-6 !mb-0"
        }
      }} />;
      $[8] = buildLink;
      $[9] = getImageUrl;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = posts.map(t5);
    $[4] = buildLink;
    $[5] = getImageUrl;
    $[6] = posts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== className || $[15] !== t2 || $[16] !== t5) {
    t6 = <section className={className}>{t2}{t5}</section>;
    $[14] = className;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}